import axios from 'axios';

const BASE_URL = '/api/work-order';

const getHeader = () => {
  const token = sessionStorage.getItem('token');
  return {
    headers: {
      Authorization: token ? `Bearer ${token}` : ''
    }
  };
};

export const workOrderApi = {
  // 1. 2차원 Matrix 통계 조회
  getMatrixCounts: async (params = {}) => {
    const res = await axios.get(`${BASE_URL}/matrix`, {
      ...getHeader(),
      params
    });
    return res.data;
  },

  // 2. 업무 목록 조회
  getList: async (params = {}) => {
    const res = await axios.get(`${BASE_URL}/list`, {
      ...getHeader(),
      params
    });
    return res.data;
  },

  // 2-1. 타임라인(간트차트) 전용 경량 업무 목록 조회
  getTimelineTasks: async (params = {}) => {
    const res = await axios.get(`${BASE_URL}/timeline-tasks`, {
      ...getHeader(),
      params
    });
    return res.data;
  },

  // 2-2. 타임라인 연도별 활성 월 초경량 조회
  getActiveMonths: async (params = {}) => {
    const res = await axios.get(`${BASE_URL}/timeline-active-months`, {
      ...getHeader(),
      params
    });
    return res.data;
  },

  // 3. 업무 상세 조회
  getDetail: async (id) => {
    const res = await axios.get(`${BASE_URL}/${id}`, getHeader());
    return res.data;
  },

  // 4. 업무 신규 등록
  create: async (formData) => {
    const res = await axios.post(`${BASE_URL}`, formData, {
      headers: {
        ...getHeader().headers,
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  },

  // 4-B. 업무지시 수정
  update: async (id, formData) => {
    const res = await axios.put(`${BASE_URL}/${id}`, formData, {
      headers: {
        ...getHeader().headers,
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  },

  // 4-C. 업무지시 삭제 (소프트 삭제)
  remove: async (id) => {
    const res = await axios.delete(`${BASE_URL}/${id}`, getHeader());
    return res.data;
  },
  delete: async (id) => {
    const res = await axios.delete(`${BASE_URL}/${id}`, getHeader());
    return res.data;
  },
  // 4-D. 업무지시 완전 삭제 (하드 삭제 - DB 영구 삭제)
  hardDelete: async (id) => {
    const res = await axios.delete(`${BASE_URL}/${id}/hard`, getHeader());
    return res.data;
  },
  // 4-E. 업무지시 재등록 (복구)
  restore: async (id) => {
    const res = await axios.put(`${BASE_URL}/${id}/action`, { action: 'restore' }, getHeader());
    return res.data;
  },
  // 4-F. 업무지시 취소
  cancel: async (id, opinion = '') => {
    const res = await axios.put(`${BASE_URL}/${id}/action`, { action: 'cancel', opinion }, getHeader());
    return res.data;
  },

  // 5. 담당자 상태 및 진척률 갱신
  updateAssigneeStatus: async (id, data) => {
    const res = await axios.put(`${BASE_URL}/${id}/assignee-status`, data, getHeader());
    return res.data;
  },

  // 5-0. 타임라인 일정/진척도 드래그 업데이트
  updateTimelineSchedule: async (id, data) => {
    const res = await axios.put(`${BASE_URL}/${id}/timeline-schedule`, data, getHeader());
    return res.data;
  },

  // 5-1. 업무지시 액션 처리 (접수, 진행불가, 업무중단, 업무재개, 강제완료)
  changeAction: async (id, data) => {
    const res = await axios.put(`${BASE_URL}/${id}/action`, data, getHeader());
    return res.data;
  },

  // 5-2. 업무지시/보고서 사유(의견) 목록 조회
  getOpinions: async (id, reportId = null) => {
    const res = await axios.get(`${BASE_URL}/${id}/opinions`, {
      ...getHeader(),
      params: reportId ? { reportId } : {}
    });
    return res.data;
  },

  // 6. 결과보고서 제출
  submitReport: async (id, formData) => {
    const res = await axios.post(`${BASE_URL}/${id}/report`, formData, {
      headers: {
        ...getHeader().headers,
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  },

  // 7. 지시자 결과보고서 승인 또는 보완요청
  reviewReport: async (id, reportId, data) => {
    const res = await axios.put(`${BASE_URL}/${id}/report/${reportId}/review`, data, getHeader());
    return res.data;
  },

  // 8. 코멘트(댓글) 등록 (PMS 구조 및 파일 첨부 지원)
  addComment: async (id, data) => {
    if (data instanceof FormData) {
      const res = await axios.post(`${BASE_URL}/${id}/comment`, data, getHeader());
      return res.data;
    }
    const payload = typeof data === 'string' ? { content: data } : data;
    const res = await axios.post(`${BASE_URL}/${id}/comment`, payload, getHeader());
    return res.data;
  },

  // 8-A. 코멘트 수정
  updateComment: async (id, commentId, data) => {
    const payload = typeof data === 'string' ? { content: data } : data;
    const res = await axios.put(`${BASE_URL}/${id}/comment/${commentId}`, payload, getHeader());
    return res.data;
  },

  // 8-B. 코멘트 파일 추가 첨부 (PMS 동일)
  addCommentFiles: async (id, formData) => {
    const res = await axios.post(`${BASE_URL}/${id}/comment/files`, formData, getHeader());
    return res.data;
  },

  // 8-1. 코멘트/피드 삭제
  deleteComment: async (id, commentId) => {
    const res = await axios.delete(`${BASE_URL}/${id}/comment/${commentId}`, getHeader());
    return res.data;
  },

  // 8-2. 요청 피드 해결/미해결 토글
  toggleCommentResolve: async (id, commentId) => {
    const res = await axios.put(`${BASE_URL}/${id}/comment/${commentId}/resolve`, {}, getHeader());
    return res.data;
  },

  // 9. 지시자 독촉 알림 발송
  sendReminder: async (id, data = {}) => {
    const res = await axios.post(`${BASE_URL}/${id}/remind`, data, getHeader());
    return res.data;
  },

  // 10. 체크리스트 (PMS TaskDrawer 동일)
  getChecklists: async (id) => {
    const res = await axios.get(`${BASE_URL}/${id}/checklists`, getHeader());
    return res.data;
  },
  createChecklist: async (id, data) => {
    const payload = typeof data === 'string' ? { content: data } : data;
    const res = await axios.post(`${BASE_URL}/${id}/checklists`, payload, getHeader());
    return res.data;
  },
  updateChecklist: async (checklistId, data) => {
    const res = await axios.put(`${BASE_URL}/checklists/${checklistId}`, data, getHeader());
    return res.data;
  },
  deleteChecklist: async (checklistId) => {
    const res = await axios.delete(`${BASE_URL}/checklists/${checklistId}`, getHeader());
    return res.data;
  },

  // 11. 파일 분류 폴더 관리 및 이동 (PMS TaskDrawer 동일)
  getFolders: async (id) => {
    const res = await axios.get(`${BASE_URL}/${id}/folders`, getHeader());
    return res.data;
  },
  createFolder: async (id, folder_name) => {
    const res = await axios.post(`${BASE_URL}/${id}/folders`, { folder_name }, getHeader());
    return res.data;
  },
  renameFolder: async (id, old_name, new_name) => {
    const res = await axios.put(`${BASE_URL}/${id}/folders/rename`, { old_name, new_name }, getHeader());
    return res.data;
  },
  deleteFolder: async (id, folderName) => {
    const res = await axios.delete(`${BASE_URL}/${id}/folders/${encodeURIComponent(folderName)}`, getHeader());
    return res.data;
  },
  updateCommentFolder: async (commentId, folder_name) => {
    const res = await axios.put(`${BASE_URL}/comments/${commentId}/folder`, { folder_name }, getHeader());
    return res.data;
  }
};
